module.exports = __webpack_public_path__ + "img/logo.99c0688a.png";